<section class="section-padding-home home-divider-dark bg-gradient-to-b from-slate-900 to-primary-900 text-white">
  <div class="container-max">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <span class="inline-block px-4 py-2 bg-primary-500/20 text-primary-300 rounded-full text-sm font-semibold mb-4 border border-primary-500/40">
        Client Testimonials
      </span>
      <h2 class="text-4xl lg:text-5xl font-bold mb-4">
        What Our Clients Say
      </h2>
      <p class="text-xl text-slate-300 max-w-2xl mx-auto">
        Real feedback from satisfied clients who trusted us with their projects
      </p>
    </div>

    <!-- Testimonials Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div 
        *ngFor="let testimonial of testimonials; let i = index"
        class="p-8 bg-white/10 backdrop-blur border border-white/20 rounded-2xl hover:border-primary-500/50 transition-all duration-300 hover:bg-white/15"
        [style.animation]="'fadeInUp ' + (0.6 + i * 0.1) + 's ease-out'"
      >
        <!-- Stars -->
        <div class="flex gap-1 mb-4">
          <svg 
            *ngFor="let star of [1,2,3,4,5]"
            class="w-5 h-5 text-yellow-400"
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
        </div>

        <!-- Testimonial Text -->
        <p class="text-lg text-slate-200 mb-6 leading-relaxed italic">
          "{{ testimonial.content }}"
        </p>

        <!-- Author -->
        <div class="flex items-center gap-4">
          <img 
            [src]="testimonial.image" 
            [alt]="testimonial.name"
            class="w-12 h-12 rounded-full object-cover border-2 border-primary-500"
          >
          <div>
            <p class="font-bold text-white">{{ testimonial.name }}</p>
            <p class="text-sm text-slate-400">{{ testimonial.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Trust Metrics -->
    <div class="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
      <div class="space-y-2">
        <p class="text-4xl font-bold text-primary-300">98%</p>
        <p class="text-slate-300">Client Satisfaction</p>
      </div>
      <div class="space-y-2">
        <p class="text-4xl font-bold text-primary-300">2L</p>
        <p class="text-slate-300">Sq. Ft. Developed</p>
      </div>
      <div class="space-y-2">
        <p class="text-4xl font-bold text-primary-300">14+</p>
        <p class="text-slate-300">Years of Experience</p>
      </div>
      <div class="space-y-2">
        <p class="text-4xl font-bold text-primary-300">250+</p>
        <p class="text-slate-300">Happy Clients</p>
      </div>
    </div>
  </div>
</section>
